import axios from "axios";

const axiosInstance = axios.create({
    baseURL: 'https://wpjwpqs74c.execute-api.ap-south-1.amazonaws.com/prod/projects'
})

export const baseImageUrl = 'https://placehold.co/800x600'

const DUMMY_PROJECTS = [
    {
        id: 1,
        name: "Dummy Project 1",
        location: "Surat",
        type: "Residence",
        doc: "2023",
        area: 12000,
        coverImg: { name: "png?text=Cover+1" },
        projectlogo: { name: "png?text=Logo+1" },
        slides: [{ name: "png?text=Slide+1" }, { name: "png?text=Slide+2" }],
        sitephotos: [{ name: "png?text=Site+1" }, { name: "png?text=Site+2" }]
    },
    {
        id: 2,
        name: "Dummy Project 2",
        location: "Mumbai",
        type: "Commercial",
        doc: "2024",
        area: 25000,
        coverImg: { name: "png?text=Cover+2" },
        projectlogo: { name: "png?text=Logo+2" },
        slides: [{ name: "png?text=Slide+1" }, { name: "png?text=Slide+2" }],
        sitephotos: [{ name: "png?text=Site+1" }, { name: "png?text=Site+2" }]
    },
    {
        id: 3,
        name: `Dummy Housing Project`,
        location: "Delhi",
        type: "Housing",
        doc: "2022",
        area: 8000,
        coverImg: { name: "png?text=Cover+3" },
        projectlogo: { name: "png?text=Logo+3" },
        slides: [{ name: "png?text=Slide+1" }, { name: "png?text=Slide+2" }],
        sitephotos: [{ name: "png?text=Site+1" }, { name: "png?text=Site+2" }]
    }
];

export const getProjects = async() => {
    return {
        projects: {
            Items: DUMMY_PROJECTS
        }
    }
}

export const getProjectType = async(type) =>{
    // Just mock filtering logic or return all if we want to be safe
    // Note: The UI might send 'housing', 'residence' etc.
    const filtered = DUMMY_PROJECTS.filter(p => p.type.toLowerCase() === type.toLowerCase());
    return {
        projects: {
            Items: filtered.length > 0 ? filtered : DUMMY_PROJECTS
        }
    }
}